import React from 'react'

function Footer() {
    return (
        <div className="footercss">
            <div className="footerdiv">
                <h2>Made with ❤️ by &nbsp; <a href="https://github.com//Rajkumar-Justcoder">Rajkumar Khistariya</a>
                </h2>
            </div>
        </div>
    )
}

export default Footer
